module.exports = __webpack_public_path__ + "static/media/fa-brands-400.32be5ed5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/webfonts/fa-brands-400.svg
// module id = 732
// module chunks = 0